module.exports = __webpack_public_path__ + "img/markforged.c7ed1a08.png";